export const getLocalStorage = key =>
    typeof window !== 'undefined' && localStorage.getItem(key) !== 'undefined'
        ? JSON.parse(localStorage.getItem(key))
        : null
export const setLocalStorage = (key, value) => window.localStorage.setItem(key, JSON.stringify(value))
